import { Button, Card, Typography } from "@hellocarbo/lasagne";
import { useTranslation } from "react-i18next";

import PageWrapper from "@/components/ui/PageWrapper";

function SuccessExternalCampaign({
  campaignUpdated = false,
}: {
  campaignUpdated?: boolean;
}) {
  const { t } = useTranslation(["externalCampaign"]);

  return (
    <PageWrapper>
      <div className="my-lg grid grid-cols-4">
        <Card isFlat className="col-start-2 col-end-4">
          <Typography as="h1" step="2" weight="bold" className="mb-xs">
            {campaignUpdated
              ? t("externalCampaign:success.create.title")
              : t("externalCampaign:success.update.title")}
          </Typography>
          <Typography className="mb-lg">
            {t("externalCampaign:success.description")}
          </Typography>
          <div className="mt-lg text-center">
            <Button as="a" href="/">
              {t("externalCampaign:success.cta")}
            </Button>
          </div>
        </Card>
      </div>
    </PageWrapper>
  );
}

export default SuccessExternalCampaign;
